module.exports = __webpack_public_path__ + "img/depament1.00501282.svg";